var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "search-input-wrapper search-simple" },
    [
      _c(
        "md-field",
        { staticClass: "input-group search-input-group" },
        [
          _c("md-input", {
            staticClass: "form-control search-input",
            attrs: {
              type: "search",
              id: "search-input",
              name: "query",
              "aria-label": "Search Users..."
            },
            on: {
              keyup: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.addApiUrls()
              }
            },
            model: {
              value: _vm.query,
              callback: function($$v) {
                _vm.query = $$v
              },
              expression: "query"
            }
          }),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "form-control-placeholder",
              attrs: { for: "search-input" }
            },
            [_vm._v("Search Users...")]
          ),
          _vm._v(" "),
          _vm.query != "" && _vm.query != null
            ? _c("span", { staticClass: "input-group-btn search-clear" }, [
                _c("input", {
                  staticClass: "icon-close submit-input",
                  attrs: { type: "submit", value: "" },
                  on: {
                    click: function($event) {
                      return _vm.clearSearch()
                    }
                  }
                })
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("span", { staticClass: "input-group-btn search-submit" }, [
            _c("input", {
              staticClass: "icon-search submit-input",
              attrs: { type: "submit", value: "search" },
              on: {
                click: function($event) {
                  return _vm.addApiUrls()
                }
              }
            })
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a270a050", { render: render, staticRenderFns: staticRenderFns })
  }
}